import { Helmet } from 'react-helmet-async'
import { useTranslation } from 'react-i18next'
import PlaceholderImg from '#/og-placeholder.jpg'
import type { FC } from 'react'
import { useRouteMatch } from 'react-router-dom'
import { useTranslationKey } from '~/utils/translations'
import { useAlternateLinks } from '~/utils/alternatelinks'

const HelpPageHelmet: FC = () => {
	const { t, i18n } = useTranslation()
	const TITLE = t('yta.se | Kontorshjälpen.', { ns: 'meta_data' })
	const DESCRIPTION = t(
		'På yta.se hittar Ni relevanta lediga lokaler snabbare än någon annanstans. Sök och hitta er verksamhets framtida kontor, butikslokal, lagerlokal eller industrilokal.',
		{ ns: 'meta_data' }
	)
	const match = useRouteMatch()
	const translationKey = useTranslationKey(match.url, 'url')
	const alternateLinks = useAlternateLinks(translationKey)
	return (
		<Helmet>
			<title key="title">{TITLE}</title>
			<meta name="og:url" content="https://yta.se/kontorshjalpen" />
			<meta name="og:title" content={TITLE} />
			<meta name="og:description" content={DESCRIPTION} />
			<meta name="og:image" content={'https://yta.se' + PlaceholderImg} />
			<meta name="description" content={DESCRIPTION} />
			{alternateLinks &&
				alternateLinks.map((link) => (
					<link
						key={link.url}
						rel="alternate"
						hrefLang={link.lng}
						href={link.url}
					/>
				))}
			{alternateLinks && (
				<link
					rel="alternate"
					hrefLang="x-default"
					href={alternateLinks.find((link) => link.lng == 'sv')!.url}
				/>
			)}
			{alternateLinks && (
				<link
					rel="canonical"
					href={alternateLinks.find((link) => link.lng == i18n.language)!.url}
				/>
			)}
		</Helmet>
	)
}

export { HelpPageHelmet }
